import {
  COMPARATIVE_TABLE_DATA,
  LOADER_STATUS,
  PREVIEW_TABLE_DATA,
  SAVE_TABLE_DATA,
  SELECTED_COMPARATIVE,
  SELECTED_SAVE,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  saveTableData: [],
  previewTableData: [],
  comparativeTableData: [],
  selectedSave: [],
  selectedComp:[],
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SAVE_TABLE_DATA:
      return {
        ...state,
        saveTableData: action.saveTableData,
      };
    case PREVIEW_TABLE_DATA:
      return {
        ...state,
        previewTableData: action.previewTableData,
      };
    case COMPARATIVE_TABLE_DATA:
      return {
        ...state,
        comparativeTableData: action.comparativeTableData,
      };
    case SELECTED_SAVE:
      return {
        ...state,
        selectedSave: action.selectedSave,
      };
       case SELECTED_COMPARATIVE:
      return {
        ...state,
        selectedComp: action.selectedComp,
      };
    default:
      return state;
  }
};

export default imsRecoSaveReducer;
